<template>
  <div
    v-if="gotWeatherData && !isNaN(temprature)"
    class="io-weather-widget row accessibility-outline"
    role="region"
    :aria-label="`Wetter: ${temprature} Grad Celsius, ${weatherData.label}`"
    aria-describedby="weather-information"
  >
    <div class="col-auto">
      <img
        :src="weatherData.icon"
        :alt="`Wetter Icon ${weatherData.label}`"
      >
    </div>
    <div class="col">
      <h5 class="weight-xs-7 mb-0">
        {{ temprature }}<sup class="weight-xs-3 text-big">°C</sup>
      </h5>
      <p id="weather-information">
        {{ weatherData.label }}<br>
        {{ weatherData.postcode }} {{ weatherData.city }}<br>
        {{ weatherData.street }} {{ weatherData.street_number }}<br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IoWeatherWidget',

  props: {
    endpoint: {
      type: String,
      required: true,
    },
    postcode: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      gotWeatherData: false,
      weatherData: {
        max: 0,
        min: 0,
        icon: null,
        label: null,
        city: null,
      },
    };
  },

  computed: {
    temprature() {
      return parseInt((this.weatherData.max + this.weatherData.min) / 2);
    },
  },

  created() {
    const weatherData = this.weatherListGetValue();

    if (weatherData !== null) {
      const currentDate = new Date();
      const diff = currentDate.diffInHours(new Date(weatherData.timestamp));

      if (diff >= 1) {
        this.weatherListRemoveData();
      } else {
        this.weatherData = weatherData;
        if (this.IOH.recVal(this.weatherData, 'max') !== null) {
          this.gotWeatherData = true;
        }
      }
    }
  },

  mounted() {
    if (!this.gotWeatherData) {
      this.getWeatherData();
    }
  },

  methods: {
    getWeatherList() {
      let weatherList = window.localStorage.getItem('io-wwd');

      if (weatherList === null) {
        weatherList = {};
      } else {
        weatherList = JSON.parse(weatherList);
      }

      return weatherList;
    },

    weatherListAddData(data) {
      const weatherList = this.getWeatherList();

      if (typeof weatherList[this.postcode] === 'undefined') {
        weatherList[this.postcode] = {};
      }

      data.timestamp = (new Date()).getTime();
      weatherList[this.postcode] = data;

      window.localStorage.setItem('io-wwd', JSON.stringify(weatherList));

      return true;
    },

    weatherListRemoveData() {
      const weatherList = this.getWeatherList();

      if (typeof weatherList[this.postcode] !== 'undefined') {
        delete weatherList[this.postcode];
      }

      window.localStorage.setItem('io-wwd', JSON.stringify(weatherList));

      return true;
    },

    weatherListGetValue() {
      const weatherList = this.getWeatherList();

      if (typeof weatherList[this.postcode] === 'undefined') {
        return null;
      }

      return weatherList[this.postcode];
    },

    getWeatherData() {
      const url = `${this.endpoint}?postcode=${this.postcode}`;

      axios.get(url).then(({ data }) => {
        if (this.IOH.recVal(data, 'max') !== null) {
          this.weatherData = data;
          this.gotWeatherData = true;
          this.weatherListAddData(data);
        } else {
          this.weatherListAddData({});
        }
      }).catch((error) => {});
    },
  },
};
</script>

<style scoped>

</style>
